import { render, staticRenderFns } from "./TinyMCEEditor.vue?vue&type=template&id=7ffc498e&scoped=true"
import script from "./TinyMCEEditor.vue?vue&type=script&lang=js"
export * from "./TinyMCEEditor.vue?vue&type=script&lang=js"
import style0 from "./TinyMCEEditor.vue?vue&type=style&index=0&id=7ffc498e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc498e",
  null
  
)

export default component.exports